<template>
  <div v-if="list.length" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    <router-link v-for="g in list" :key="g.slug" :to="g.url" class="block bg-white rounded-2xl border border-gray-100 p-5 hover:shadow-md transition">
      <span class="text-xs text-[#2563EB] font-medium">{{ g.group_label }}</span>
      <h3 class="font-semibold text-[#1E293B] mt-1 mb-1">{{ g.title }}</h3>
      <p class="text-sm text-[#64748B]">{{ g.description }}</p>
    </router-link>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({ guides: { type: Array, default: () => [] } });
const list = computed(() => (props.guides || []).filter(Boolean));
</script>
